import core from '@/core/index';
import '@/assets/styles/mixin.css';
import '@/assets/styles/global.less';
import '@/assets/styles/dark-style.less';
import hack from '@/assets/js/hack';
import { WechatShareConfig, RmtShareConfig } from '@/assets/js/share.js';
import store from '@/core/config.store';
// web test token
// $$.token.set(
//   ''
// );
function Live() {}

// 直播信息
Live.prototype.load = async function(id) {
  try {
    // userinfo
    const userinfo = await this.getUserinfo();
    // room
    const room = await this.getRoom(id);
    // user sign
    if (userinfo.auth !== 0) {
      Object.assign(userinfo, await this.getUserSign(room.siteId));
    }

    if (!room.roomSettingContent.roomAuth.auth) {
      localStorage.setItem(id, JSON.stringify({ auth: false, userId: userinfo.id }));
    }

    // module
    return { room, userinfo };
  } catch (err) {
    throw new Error(err);
  }
};

// 房间信息
Live.prototype.getRoom = function(id) {
  const auth = JSON.parse(localStorage.getItem(id)) || {};
  const data = { roomId: id };
  auth.auth && auth.code && (data.roomPass = auth.code);
  return new Promise((resolve, reject) => {
    $$.module.core.$api.room({
      data,
      success: (data) => {
        resolve(data);
      },
      exception: (exception) => {
        reject(exception.msg);
      }
    });
  });
};

// 用户信息
Live.prototype.getUserinfo = function() {
  return new Promise((resolve, reject) => {
    Promise.resolve($$.token.get())
      .then((token) => {
        if (token) {
          $$.module.core.$api.userinfo({
            data: {},
            success: (data) => {
              data.auth = 1;
              resolve(data);
            },
            exception: (exception) => {
              reject(exception.msg);
            }
          });
        } else {
          resolve({ auth: 0 });
        }
      })
      .catch(() => {
        resolve({ auth: 0 });
      });
  });
};

// 用户签名
Live.prototype.getUserSign = function(siteId) {
  return new Promise((resolve, reject) => {
    $$.module.core.$api.userSig({
      data: { siteId },
      success: (data) => {
        resolve(data);
      },
      exception: (exception) => {
        reject(exception.msg);
      }
    });
  });
};

// 页面信息
Live.prototype.getPage = function(room) {
  if ($$.util.getParam('mode') === 'anchor') return 'anchor/home';
  // 是否开启引导页 + 直播状态判断
  return room.guideSettingContent.guideFlg === '0' && room.roomSettingContent.roomInfo.liveState === '1' ? 'interview/teaser' : 'interview/home';
};
// 分享
Live.prototype.configShare = function(room) {
  const shareInfo = room.roomSettingContent?.shareInfo;
  const isNotShare = room.roomRefurbish.find((data) => data.refurbishName === 'share')?.refurbishFlg !== '0' || !shareInfo;
  console.log('isNotShare', isNotShare);
  const shareConfig = {
    title: shareInfo?.shareTitle || room.roomSettingContent?.roomInfo?.roomTitle || '',
    desc: shareInfo?.shareDepiction || room.roomSettingContent?.roomInfo?.roomTitle || '',
    link: shareInfo?.shareUrl || window.location.href,
    imgUrl: shareInfo?.shareImage || room.roomSettingContent?.roomInfo?.liveImage || '',
    hiddenShare: isNotShare
  };
  console.log('shareConfig', shareConfig);
  if (hack.isRmt) {
    new RmtShareConfig(shareConfig);
  } else if (hack.isWechat) {
    new WechatShareConfig(shareConfig);
  }
};
// 标题
Live.prototype.headTitle = (room) => {
  document.getElementById('head-title').text = room.roomSettingContent?.roomInfo?.roomTitle || '全视直播';
};

// 埋点
Live.prototype.buriedPoint = (room) => {
  var script = document.createElement('script');
  script.src = `//gl.ewdcloud.com/salmon.php?appkey=${room.appId || 203}`;
  var action = document.getElementsByTagName('script')[0];
  action.parentNode.insertBefore(script, action);
};

Live.prototype.execExtra = (room) => {
  try {
    eval(`(function() {${room.roomSystemInfo.appImageJson?.extra}})();`);
  } catch (error) {
    console.log('extra error!');
  }
};

// 商城token
Live.prototype.mallInfo = async (room) => {
  // 是否开启直播带货
  if (room.roomRefurbish.find((data) => data.refurbishName === 'bringGoods').refurbishFlg === '0') {
    console.log('get mall info...');
    await store.dispatch('getMallInfo');
    await store.dispatch('getMallToken');
  }
};

// 初始化直播间数据
Live.prototype.initData = async function() {
  const id = $$.util.getParam('id');
  const { room, userinfo } = await live.load(id);

  if (!core.module.data) {
    core.module.data = {};
  }
  if (!core.module.data.room) {
    core.module.data.room = {};
  }
  core.module.data.userinfo = userinfo;
  Object.assign(core.module.data.room, room);

  return {
    room: core.module.data.room,
    userinfo
  };
};

// live
const live = new Live();
window.__LIVE__ = live;
export { live };
// Start
(async () => {
  window.$hack = hack;
  hack.execute(async () => {
    try {
      const id = $$.util.getParam('id');
      if (!id) {
        throw new Error('404');
      }

      const { room } = await live.initData();
      console.log('room', room);
      // 分享配置
      live.configShare(room);
      // 商城信息
      await live.mallInfo(room);

      // 设置页面标题
      live.headTitle(room);
      // 埋点
      live.buriedPoint(room);

      $$.route.push(live.getPage(room));

      live.execExtra(room);
    } catch (exception) {
      $$.route.message(exception.message);
    }
    // mount
    core.config().mount();

    // loading
    loading(false, 200);
  });
})();

// Loading
function loading(display, sleep = 0) {
  setTimeout(() => {
    const loading = document.getElementById('loading');
    loading && (loading.style.display = display ? '' : 'none');
  }, sleep);
}
